import { makeAutoObservable, runInAction } from 'mobx';
import { makePersistable } from 'mobx-persist-store';
export default class CustomerStore {
	constructor() {
		makeAutoObservable(this);
		makePersistable(this, {
			name: 'CustomerStore',
			properties: [
				'customers',
				'selectedCustomer',
				'mappedCustomers',
			],
		});
	}

	customers = [];
	selectedCustomer = {};
	mappedCustomers = [];
	loading = false;

	reset = () => {
		this.customers = [];
		this.mappedCustomers = [];
		this.selectedCustomer = {};
	};

	setLoading = async isLoading => {
		runInAction(() => {
			this.loading = isLoading;
		});
	};

	setCustomers = async customers => {
		runInAction(async () => {
			this.customers = customers;
		});
	};
	setMapCustomers = async state => {
		runInAction(async () => {
			this.mappedCustomers = state;
		});
	};

	setSelectedCustomer = async state => {
		runInAction(async () => {
			this.selectedCustomer = state;
		});
	};
}
